import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');

// If react-snap has pre-rendered the page, hydrate instead of full render
if (rootElement.hasChildNodes()) {
  // STALE-10: was importing hydrateRoot as a named import alongside the
  // default ReactDOM import. Both come from 'react-dom/client', and
  // ReactDOM.hydrateRoot is the same function. Single import path now.
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// STALE-09 / LOG-19: reportWebVitals() was called without a callback,
// so the dynamic import inside never fired and no metrics were ever
// reported anywhere. Removed the call + the file + the web-vitals npm
// package. If we ever want real web-vitals reporting, the right
// approach is a server endpoint or a third-party (Sentry, Plausible).
